import React, { memo } from 'react';

import classNames from 'classnames';

import { useYandexMetrika } from '@shared/lib';

import cls from './Tabs.module.css';
import { Icon } from '../Icon/Icon';
import { Skeleton } from '../Skeleton/Skeleton';

interface Tab {
    title: string;
    value: string;
    action?: () => void;
}

interface TabsProps {
    classes?: string;
    onChange: (value: string) => void;
    tabsList: Tab[];
    activeTab: string;
    isLoading?: boolean;
    errorTabs?: string;
    isError?: boolean;
    classesTabs?: string;
}

export const Tabs = memo(
    ({
        classes,
        tabsList,
        activeTab,
        onChange,
        isLoading,
        errorTabs,
        isError,
        classesTabs,
    }: TabsProps) => {
        const { trackEvent } = useYandexMetrika();
        return (
            <div
                className={classNames(cls.Tabs, [classes], {
                    [cls.loading]: isLoading,
                })}
            >
                {isLoading ? (
                    <Skeleton width={150} height={18} border="6px" />
                ) : (
                    tabsList.map(({ value, title, action }) => (
                        <div className={cls.wrapper} key={value} id={value && value}>
                            <div
                                data-tab-value={value}
                                className={classNames(cls.tab, [classesTabs], {
                                    [cls.active]: activeTab === value,
                                })}
                                key={value}
                                onClick={() => {
                                    if (activeTab != 'eventJournal') {
                                        trackEvent('eventJournal', 'tab', {
                                            actionData: 'кликнули на таб Журнал событий',
                                        });
                                    }
                                    if (action) {
                                        action();
                                    } else {
                                        onChange(value);
                                    }
                                }}
                            >
                                {title}
                            </div>
                            {errorTabs === value && (
                                <div className={cls.icon}>
                                    {isError && <Icon iconName="tabError" />}
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        );
    }
);
